import { render, staticRenderFns } from "./SalesQuotation.vue?vue&type=template&id=4b69b631"
import script from "./SalesQuotation.vue?vue&type=script&lang=js"
export * from "./SalesQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports